import { render, staticRenderFns } from "./forms.vue?vue&type=template&id=0924a3c5&scoped=true&"
import script from "./forms.vue?vue&type=script&lang=js&"
export * from "./forms.vue?vue&type=script&lang=js&"
import style0 from "./forms.vue?vue&type=style&index=0&id=0924a3c5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0924a3c5",
  null
  
)

export default component.exports